import { FC } from 'react'

const NotFound: FC = () => {
  return null
}

export default NotFound
